export const environment = {
  production: false,
  BackendHost: 'https://dataapi.cofinex.io/',
  url_key: "jkJFDKFDfdzNpkDjfVtdWdAO",
  //BackendHost: 'http://localhost:3972/',
  //url_key: "jkJFDKFDfdzNpkDjfVtdWdAO"

};

